<template>
  <v-container fluid>
    <section>
      <KpiCards class="mb-3" :items="kpiItems" :loading="!summaries.length" :skeleton="5" />

    <data-table
      :headers="headers"
      :items="allProducts"
      commit="SET_ALL_PRODUCTS"
      :viewItem="viewItem"
      :editItem="editItem"
      :deleteItem="deleteItem"
      :proStatus="proStatus"
    >
      <div slot="activator" class="row mb-4">
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-2">
          <v-card-title class="py-0 ps-products-title"> ສິນຄ້າທັງໝົດ </v-card-title>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-2 text-right offset-lg-3">
          <TextSelect
            :dense="true"
            :placeholder="false"
            :items="categories"
            label="category"
            v-model="category_id"
            text="la_name"
            itemValue="id"
          />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-3 text-right">
          <TextSearch
            v-model="search"
            @search="fetchItem()"
            @onClear="
              search = '';
              fetchItem();
            "
          />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-2 text-right">
          <v-btn
            min-width="auto"
            class="mr-3"
            depressed
            to="/trash-products"
          >
            <v-icon small>fal fa-trash</v-icon>
          </v-btn>
          <v-btn
            min-width="auto"
            depressed
            to="/manage-add-product"
          >
            <v-icon left small>fal fa-plus-circle</v-icon>
            ເພີ່ມສິນຄ້າ
          </v-btn>
        </div>
      </div>
    </data-table>

    <app-custom-dialog
      v-model="dialog"
      :footer="false"
      title="description"
      @submit="submitForm"
    >
      <div slot="activator">
        <AppDetail :item="form" />
      </div>
    </app-custom-dialog>
    <app-loading :overlay="overlay" />
  </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import { productHead } from "@/utils/head";
import AppDetail from "@/components/products/details";
import { myMixin } from "@/mixin/main";
import { success, confirm } from "@/controllers/alert";
import TextSelect from "@/components/global/TextSelect";

export default {
  mixins: [myMixin],
  data: () => ({
    overlay: false,
    search: "",
    category_id: {
      id: 0,
      la_name: "ທັງໝົດ",
    },
    update: false,
    dialogAdd: false,
    dialog: false,
    headers: productHead(),
    form: {},
    summaries: [],
  }),
  async created() {
    await this.fetchSummary();
    await this.fetchCategory();
    await this.fetchItem();
  },
  watch: {
    category_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search = "";
        this.fetchItem();
      }
    },
  },
  components: {
    DataTable,

    AppDetail,
    TextSelect,
  },
  computed: {
    kpiItems() {
      return this.summaries.map((item, index) => ({
        key: index,
        label: item.title,
        icon: item.icon,
        value: Number(item.total || 0),
      }));
    },
    ...mapGetters({
      category: "index/category",
      allProducts: "index/allProducts",
    }),
    categories() {
      if (
        this.category != null &&
        this.category != undefined &&
        this.category.length
      ) {
        const object = {
          id: 0,
          name: "ທັງໝົດ",
        };
        this.category.unshift(object);
        return this.category;
      } else {
        return [];
      }
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchCategory() {
      const body = {
        url: "categories",
        that: this,
        commit: "SET_CATEGORY",
      };
      await this.fetch(body);
    },
    async fetchItem() {
      this.overlay = true;
      const body = {
        that: this,
        url: `products_all?cat_id=${this.category_id.id}&q=${this.search}`,
        commit: "SET_ALL_PRODUCTS",
      };
      await this.fetch(body);
      this.overlay = false;
    },

    async newItem() {
      await Help.clearForm(this.form, this);
      await this.fetchItem();
      this.update = false;
      this.dialogAdd = !this.dialogAdd;
    },
    editItem({ id }) {
      this.$router.push(`/manage-edit-product/${id}`);
    },
    async fetchSummary() {
      try {
        const { data } = await this.$http.get(`/get_summary`);
        if (data.status) {
          this.summaries = data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteItem({ id }) {
      const { isConfirmed } = await confirm({
        props: this,
        text: "want_to_delete",
      });
      if (isConfirmed) {
        try {
          const { data } = await this.$http.delete(`products/${id}`);
          if (data.status) {
            await Help.clearForm(this.form, this);
            await this.fetchItem();
            await success(this, data.message);
          } else {
            error(this, data?.message || "error_occurred");
          }
        } catch (err) {
          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "error_occurred";
          error(this, typeof msg === "string" ? msg : "error_occurred");
        }
      }
    },
    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
    async submitForm() {
      var result;
      try {
        if (this.update) {
          result = await this.$http.post(
            `product_size/${this.form.id}`,
            this.form
          );
        } else {
          result = await this.$http.post("product_size", this.form);
        }
        if (result.data.status) {
          this.dialogAdd = !this.dialogAdd;
          await Help.clearForm(this.form, this);
          await this.fetchItem();
          await success(this, data.message);
        }
      } catch (error) {
        console.log("error", error);
      }
    },

    async proStatus(val) {
      try {
        const { data } = await this.$http.put(`product_active/${val.id}`);
        if (data.status) {
          await this.fetchItem();
          await success(this, data.message);
        } else {
          await errorAlert(this, data.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.ps-card-soft {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 16px !important;
  box-shadow: none !important;
  transition: box-shadow 0.15s ease;
}

.ps-summary-icon {
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
}

.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
